import type { FormElement, IndexerTitleProperties } from '../../model/form.types';
import type { StaticDefinition } from '../../model/types';
import { textStyle } from './shared';

type IndexerTitleElement = FormElement & { properties: IndexerTitleProperties };

export const indexerTitleDefinition: StaticDefinition<IndexerTitleElement> = {
  kind: 'static',
  type: 'INDEXER_TITLE',
  compile: (element, context) => ({
    kind: 'static',
    id: element.id,
    type: 'INDEXER_TITLE',
    text: context.titles.indexer ?? '',
    style: textStyle(element),
    visible: true,
    element,
  }),
};
